/**
 * GTM IMPLEMENTATION
 */

// import TagManager from "@sooro-io/react-gtm-module";

const standardEvents = [
  "add_payment_info",
  "add_shipping_info",
  "add_to_cart",
  "add_to_wishlist",
  "begin_checkout",
  "generate_lead",
  "login",
  "purchase",
  "search",
  "sign_up",
  "view_item",
];

const isScriptExists = () => {
  const check = !!window.dataLayer;
  // if (check) console.info("[gtmAdapter] dataLayer is found!");
  if (!check) console.warn("[gtmAdapter] dataLayer not found!");

  return check;
};

const hasInstance = () => {
  if (!isScriptExists()) {
    return false;
  }

  // Undocumented method
  return window.dataLayer?.[0]?.["gtm.start"] > 0;
};

const isInstanceExists = (gtmId) => {
  if (!isScriptExists() || !hasInstance()) {
    return false;
  }

  // Undocumented method
  if (window.google_tag_manager) {
    const configuredIds = Object.keys(window.google_tag_manager).filter(
      (key) => key.startsWith("G-") || key.startsWith("GT-") || key.startsWith("GTM-"),
    );

    return configuredIds.includes(gtmId);
  }

  return false;
};

const register = (gtmId) => {
  // TagManager.initialize({ gtmId: gtmId });
  console.warn("[gtmAdapter] register: Skipped! Please register at index.html");
};

const pageViewSingle = (gtmId) => {
  // console.warn("[gtmAdapter] pageViewSingle: Multi-instance mode is not supported. Falling back to normal mode.");
  pageView();
};

const pageView = () => {
  console.debug("[gtmAdapter] pageView");
  // TagManager.dataLayer({
  //   dataLayer: {
  //     event: "page_view",
  //   },
  // });
  window.dataLayer.push({ event: "page_view" });
};

const trackSingle = (gtmId, eventName, eventData = {}) => {
  // console.warn("[gtmAdapter] trackSingle: Multi-instance mode is not supported. Falling back to normal mode.");
  track(eventName, eventData);
};

const track = (eventName, eventData = {}) => {
  console.debug("[gtmAdapter] track:", eventName, eventData);
  // TagManager.dataLayer({
  //   dataLayer: {
  //     event: eventName,
  //     ...eventData,
  //   },
  // });
  window.dataLayer.push({
    event: eventName,
    ...eventData,
  });
};

const gtmAdapter = {
  isScriptExists,
  hasInstance,
  isInstanceExists,
  register,
  pageViewSingle,
  pageView,
  trackSingle,
  track,
};

export default gtmAdapter;
